import styled from '@emotion/styled';
import moment from 'moment';
import { BondBidAskType, BondEntity } from '../../../../entities/bond.entity';
import { PRIMARY } from '../../../../shared/colors';
import { formatNum } from '../../../../shared/constants';
import { TitleLine } from '../SearchContent';

const Container = styled.div`
  zoom: 0.9;
  flex: 1;

  > .top {
    background-color: ${PRIMARY};
    padding: 5px;
    font-family: Poppins-R;
    font-size: 15px;
    border-radius: 10px;
    text-transform: uppercase;
    color: orange;
    padding-left: 10px;
  }

  > .content {
    padding: 5px;
    font-family: Poppins-R;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(100vh - 330px);

    p {
      margin: 0px;
    }

    &::-webkit-scrollbar {
      width: 0.5vw;
    }

    &::-webkit-scrollbar-thumb {
      background-image: linear-gradient(to bottom, #eceff1, #eceff1);
      border-radius: 10px;
    }
  }
`;

export const InstrumentDetail = ({
  selectedBond,
  bondBidAsk,
}: {
  selectedBond?: BondEntity;
  bondBidAsk: BondBidAskType;
}) => {
  return (
    <Container>
      <div className='top'>Details</div>

      <div className='content'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}
        >
          <div>
            <p>BID : </p>
            <p>ASK : </p>
          </div>
          <div>
            <p style={{ color: 'green' }}>{formatNum(bondBidAsk.bid)} XAF</p>
            <p style={{ color: 'red' }}>{formatNum(bondBidAsk.ask)} XAF</p>
          </div>
        </div>
        <TitleLine>Détails</TitleLine>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}
        >
          <div>
            <p>Pays Emetteur : </p>
            <p>Code : </p>
            <p>Instrument : </p>
            <p>Date d'émission : </p>
            <p>Date maturation : </p>
            <p>Durée maturation (mois) : </p>
            <p>Fréq. paiement : </p>
            <p>Valeur nominale : </p>
            <p>Coupon : </p>
          </div>
          <div>
            <p>{selectedBond?.pays || '---'}</p>
            <p
              style={{
                width: 120,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {selectedBond?.code || '---'}
            </p>
            <p>{selectedBond?.instrument || '---'}</p>
            <p>
              {selectedBond?.dateEmission
                ? moment(selectedBond?.dateEmission).format('DD/MM/YYYY')
                : '---'}
            </p>
            <p>
              {selectedBond?.dateMaturite
                ? moment(selectedBond?.dateMaturite).format('DD/MM/YYYY')
                : '---'}
            </p>
            <p>{selectedBond?.dureeMaturite || '---'}</p>
            <p>{selectedBond?.frequencePaiement || '---'}</p>
            <p>{formatNum(selectedBond?.valeurNominale) || '---'}</p>
            <p>{selectedBond?.tauxMarginal || '---'} %</p>
          </div>
        </div>
      </div>
    </Container>
  );
};
